import { createStore } from "vuex";

export default createStore({
  state: {
    logged: false,
    validated: false,
    transaction_data: [],
    transaction_label: '',
    transaction_balance: '',
    clickedEdit: null,
    banks: {},
    modules: {},
    sched: {},
    forgot_password_payload: {
      uuid:null,
      hash:null,
      pin:null,
    },
    recovery:{
      hash:null,
      pin:null,
      otp_token:null,
      otp_pin:null,
      uuid:null,
    },
    election_config:{
      code:'GA00000002',
      server_time:null,
      date_start : null,
      date_end: null,
      can_vote:null,
      started:false,
      voted:null,
      registration_start:null,
      registration_end:null,
      registration_ended:null,
      registration_started:null,
      election_registered:null,
      voting_ended:null,
      finished:false,
      ballot_no:null,
      total_votes:null,
      voter_key:null,
    },
    sga_config: {
      code: null,
      date: null,
      title: null,
      uuid: null,
      eligible: null,
      has_voted: null,
      has_registered: null,
      schedules: {
        has_started: null,
        has_ended: null,
        start_date: null,
        end_date: null,
      }
    },
    credentials: {
      noContact: null,
      enrolled_pin: null,
      edit_temporary: null,
      express:null,
      first_name:null,
      last_name:null,
      middle_name:null,
      suffix: null,
      birthdate: null,
      skipped_info: null,
      age: null,
      gender:null,
      regular:null,
      account_no : null,
      serial_no : null,
      email : null,
      mobile : null,
      pso_enroll: null,
      pin_update: null,
      tin:null,
      has_pin:null,
      name : null,
      otp:null,
      username : null,
      password : null,
      membership_type:null,
      membership_date:null,
      status:null,
      registered_date:null,
      qr : null,
      uuid : null,
      hash : null,
      key : null,
      deactivated:null,
      config: {
        type: null,
        status: null,
      }
    },
    membership_details: {
      ref_account:null,
      ref_name:null,
      confirmed:null,
      interview_date: null,
      pso:null,
      citizenship:null,
      sss_number:null,
      gsis_number:null,
      first_name: null,
      last_name: null,
      middle_name: null,
      rank: null,
      birth_date: null,
      place_of_birth: null,
      gender: null,
      suffix:null,
      civil_status: null,
      snap:null,
      afp_serial_number: null,
      branch_of_service: null,
      employee_status: null,
      gender_text:null,
      employee_status_text:null,
      civil_status_text:null,
      branch_of_service_text:null,
      rank_text:null,
      schedule_key:null,
      pso_text:null,
      tin: null,
      mobile: null,
      email: null,
      re_email:null,
      mofirst_name: null,
      molast_name: null,
      momiddle_name: null,  
      fafirst_name: null,
      falast_name: null,
      famiddle_name: null, 
      spfirst_name: null,
      splast_name: null,
      spmiddle_name: null,
      spfirst_name2: null,
      splast_name2: null,
      spmiddle_name2: null,
      spfirst_name3: null,
      splast_name3: null,
      spmiddle_name3: null,
      spfirst_name4: null,
      splast_name4: null,
      spmiddle_name4: null,
      beneficiaries:[],  
      spouse:[],
      resstreet_address: null,
      reszip_code: null,
      resprovince: null,
      rescity: null,
      resbrngy: null,
      altstreet_address: null,
      altzip_code: null,
      altprovince: null,
      altcity: null,
      altbrngy:null,
      signature:null,
      front:null,
      back:null,
      sc:null,
      sc_agree:null,
      wcp_agree:null,
      cisa_agree:null,
      pmes_dt:null,
      email_pin:null,
      phone_pin:null,
    },
    user:{
      selected_candidatesBodOf:null,
      selected_candidatesBodEp:null,
      selected_candidatesBodCv:null,
      selected_candidatesElecomOf:null,
      selected_candidatesElecomEp:null,
      selected_candidatesElecomCv:null,
      selected_candidatesAudit:null,
      date_started:null,
      date_submitted:null,
      skip:true,
    },
    references:{
      branch_of_service:[],
      employment_status_options:[],
      branches:[],
      civil_status:[],
      gender:[],
      ranks:[],
    },
    vote_schedule: {
      started: null,
      submitted: null,
    },
    voter: {
      uuid: null,
      key: null,
      first_name: null,
      middle_name: null,
      last_name: null,
      suffix: null,
      account_number: null,
      serial_number: null,
      secret_key: null,
    },
    ballot: {
      ballot_no: null,
      voter_key: null,
      total_votes: null,
    },
    notice: {
      bod: null,
      audit: null,
      elecom_officer: null,
      elecom_ep: null,
    },
    schedules: {
      registration_start: null,
      registration_started: null,
      registration_end: null,
      registration_ended: null,
      voting_start: null,
      voting_started: null,
      voting_end: null,
      voting_ended: null,
    },
    candidates: {
      bod: [],
      elecom: [],
      audit: [],
    },
    gaCandidates: {
      bod: [],
      elecom: [],
      audit: [],
    },
    selectedVotes: {
      bod: [],
      elecom: [],
      audit: [],
    },
    ackNotice: {
      bod: false,
      elecom: false,
      audit: false,
    },
    //Bank Account Opening
    get_info: null,
    lookup: {},
    provinces: [],
    // Tab 1 - Personal Information
    formDataPNB: {
      // Personal Information
      last_name: '',
      first_name: '',
      middle_name: '',
      suffix: '',
      account_no: '',
      member_key: '',
      
      // IDs Presented
      id_code: '',
      id_number: '',
      id_expiry: '',
      tin: '',
      birth_date: '',
      birth_place: '',
      nationality: '',
      nationality_other: '',
      
      // Present Address
      house_no: '',
      street: '',
      brgy: '',
      province: '',
      municipality: '',
      country: '',
      zip_code: '',
      residence: '',
      
      // Permanent Address
      ad_same: false,
      per_house_no: '',
      per_street: '',
      per_brgy: '',
      per_province: '',
      per_municipality: '',
      per_country: '',
      per_zip_code: '',
      per_residence: '',
      
      // Tab 2 - Contact Information
      telephone_no: '',
      social_media: '',
      mobile_no: '',
      email: '',
      
      // Employment Information
      emp_type: '',
      emp_type_others: '',
      emp_name: '',
      nature_of_work: '',
      work_oth: '',
      emp_no: '',
      emp_street: '',
      emp_brgy: '',
      emp_province: '',
      emp_municipality: '',
      emp_country: '',
      emp_zipcode: '',
      emp_email: '',
      
      // Tab 3 - Source of Funds
      src_fund: '',
      src_others: '',
      src_amount: '',
      rem1_name: '',
      rem1_relationship: '',
      rem2_name: '',
      rem2_relationship: '',
      rem3_name: '',
      rem3_relationship: '',
      
      // US FATCA
      us_citizen: '',
      civil_status: '',
      gender: '',
      citizenship: '',
      us_others: '',
      
      // Mother's Maiden Name
      mother_last_name: '',
      mother_first_name: '',
      mother_middle_name: '',
      
      // Spouse Information
      sp_last_name: '',
      sp_first_name: '',
      sp_middle_name: '',
      sp_birth_date: '',
      sp_occupation: '',
      sp_no: '',
      sp_street: '',
      sp_brgy: '',
      sp_province: '',
      sp_municipality: '',
      sp_country: '',
      sp_zip_code: '',
      
      // Products/Services
      int_products: '',
    },
    formDataRCBC: {
      // Tab 1 - Personal Information
      last_name: "",
      first_name: "",
      middle_name: "",
      account_no: "",
      member_key: "",
      gender: "",
      marital_status: "",
      date_of_birth: "",
      place_of_birth: "",
      country: "",
      nationality: "",
      citizenship: "",
      province: "",
      city: "",
      brgy: "",
      street: "",
      house_no: "",
      zip_code: "",
      tin: "",
      sss: "",
      reason: "",
      mobile_no: "",
      email: "",
      purpose_of_stay: "",
      type_visa: "",
      length_stay: "",
      req_visit: "",
      specify_purpose: "",
      affiliated_org: "",


      // Tab 2 - Other Personal Information
      us_resident: "",
      us_citizen: "",
      us_tin: "",
      country_resident: "",
      name_pep: "",
      person_pep: "",


      // Tab 3 - Occupation Details
      occupation: "",
      employer_name: "",
      nature_of_work: "",
      office_contact_number: "",
      office_address: "",

      purpose_of_account: "",
      fsourceoffund: "",
      amount_of_initial: "",
      mailing_address: "",
      source_of_wealth: "",
      monthly_expected: "",

      rel_sender: "",
      country_wealth: "",
      occupation_sender: "",
      nature_work_sender: "",
      purpose_allowance: "",
      accnt_beneficial: "",
      banking: "",
      credit_card: ""
    },
  },
  getters: {
    getFormDataPNB: state => state.formDataPNB,
    getFormDataRCBC: state => state.formDataRCBC,
  },
  mutations: {
    setSelectedVotes(state, { category, votes }) {
      state.selectedVotes[category] = votes;
    },
    clearSelectedVotes(state) {
      state.selectedVotes = {
        bod: [],
        elecom: [],
        audit: [],
      };
    },
    setFormData(state, payload) {
      state.formDataPNB = {
        ...state.formDataPNB,
        ...(payload || {}),
      };
    },
    setFormDataPNB(state, payload) {
      state.formDataPNB = {
        ...state.formDataPNB,
        ...(payload || {}),
      };
    },
    setFormDataRCBC(state, payload) {
      state.formDataRCBC = {
        ...state.formDataRCBC,
        ...(payload || {}),
      };
    },
    updateAllFormData(state, payload) {
      state.formDataRCBC = {
        ...state.formDataRCBC,
        ...(payload || {}),
      };
    },
    setTransactionData(state, transaction_data) {
      state.transaction_data = transaction_data;
    },
  },
  actions: {},
  modules: {},
});
